export default {"src":"/_next/static/media/up-arrow.ca5d8427.svg","height":6,"width":12,"blurWidth":0,"blurHeight":0};